
import { defineComponent } from 'vue';
import easteregg from '@/components/easteregg.vue';
import Navigation from '@/components/Navigation.vue';
import Footer from '@/components/Footer.vue';

export default defineComponent({
  name: 'nomeacuerdo.co',
  components: {
    Navigation,
    Footer,
    easteregg,
  },
  data() {
    return {
      cheemz: true,
      duration: 500,
    };
  },
  methods: {
    egg() {
      this.cheemz = false;
      setTimeout(() => { this.cheemz = true; }, this.duration);
    }
  }
});
